import React, { useState, useEffect } from "react";
import PageTop from "./Components/PageTop";
import { themsField, Colors } from "@/config/config";
import { ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { AppProvider, useAppContext } from "./AppContext";

// antd 内置文案与日期面板统一用中文（如月份显示为“2026年7月”）
dayjs.locale("zh-cn");

const App = () => {
  const [curTheme, setCurTheme] = useState<any>("light");
  useEffect(() => {
    setCurTheme(
      localStorage.getItem(themsField)
        ? localStorage.getItem(themsField)
        : "light"
    );
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    Object.entries(Colors).forEach(([key, value]) => {
      root.style.setProperty(`--color-${key.toLowerCase()}`, value);
    });
  }, []);

  return (
    <div className={curTheme}>
      <ConfigProvider
        locale={zhCN}
        theme={{
          token: {
            colorSuccess: Colors.SECONDARY,
            colorLink: Colors.SECONDARY,
            wireframe: true,
            colorPrimaryBg: Colors.NEUTRAL_5,
            colorPrimary: Colors.PRIMARY,
            colorInfo: Colors.PRIMARY,
          },
          components: {
            Button: {
              colorPrimary: Colors.TEXT,
            },
            Tabs: {
              cardBg: Colors.PRIMARY,
              itemColor: "#FFF",
            },
          },
        }}
      >
        <PageTop setCurTheme={(t: any) => setCurTheme(t)} />
      </ConfigProvider>
    </div>
  );
};
const RootComponent = () => {
  return (
    <AppProvider>
      <App />
    </AppProvider>
  );
};
export default RootComponent;
